import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store.ts';
import { ToastProvider } from './contexts/ToastContext';
import Home from './pages/Home';
import GetStarted from './pages/GetStarted';
import Layout from './components/lay-out/Layout';
import ScrollToTop from './components/ScrollToTop';
import WhatsAppButton from './components/WhatsAppButton';
import './i18n';

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastProvider>
          <Router>
            <ScrollToTop />
            <div className="App">
              <Routes>
                <Route path="/" element={<Layout />}>
                  <Route index element={<Home />} />
                </Route>
                <Route path="/get-started" element={<GetStarted />} />
              </Routes>
            </div>
            <WhatsAppButton />
          </Router>
        </ToastProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;